import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import InfiniteScroll from 'react-infinite-scroller'

import styles from './styles'
import { PlaceholderContent } from 'utils'
import { Loading, Card } from 'components'
import { useFeedTeamArticlesQuery } from 'graphql/__generated__/graphql'

const useStyles = makeStyles(styles)

const Stories: React.FunctionComponent<any> = props => {
	const { teamId = null, teamName } = props
	const classes = useStyles()
	// const { t } = useTranslation()
	const { data, loading, fetchMore, refetch } = useFeedTeamArticlesQuery({
		fetchPolicy: 'network-only',
		variables: {
			teamId,
			first: 3,
			after: null,
		},
	})

	const articles = data
		? data &&
		  data?.feed_team_articles &&
		  data?.feed_team_articles?.edges?.map((edge: any) => edge.node)
		: []
	const hasNextPage = data
		? data &&
		  data.feed_team_articles &&
		  data.feed_team_articles.pageInfo.hasNextPage
		: false
	return (
		<Grid
			className={classes.profileMainContent}
			container={true}
			direction="column"
		>
			<Grid
				item={true}
				className={`${classes.sectionContent} ${classes.storiesSection}`}
			>
				{!loading ? (
					<section
						style={{
							flexGrow: 1,
							display: 'flex',
							flexDirection: 'column',
						}}
					>
						<InfiniteScroll
							pageStart={0}
							loadMore={() =>
								fetchMore({
									variables: {
										after: data?.feed_team_articles?.edges[
											data?.feed_team_articles.edges
												.length - 1
										].cursor,
									},
									updateQuery: (
										previousQueryResult,
										{ fetchMoreResult },
									) => {
										if (
											!fetchMoreResult ||
											!fetchMoreResult.feed_team_articles
										) {
											return previousQueryResult
										}

										const { edges: newEdges, pageInfo } =
											fetchMoreResult.feed_team_articles

										return newEdges.length > 0
											? {
													// Put the new articles at the end of the list and update `pageInfo`
													feed_team_articles: {
														__typename:
															previousQueryResult
																.feed_team_articles
																?.__typename,
														edges: [
															...(previousQueryResult
																.feed_team_articles
																?.edges || []),
															...newEdges,
														],
														pageInfo,
													},
											  }
											: previousQueryResult
									},
								})
							}
							hasMore={hasNextPage ?? false}
							loader={
								<div
									style={{ flexGrow: 1, display: 'flex' }}
									key={'loading'}
								>
									<Loading size={48} />
								</div>
							}
						>
							{articles && articles.length > 0 ? (
								articles?.map((article: any) => (
									<Card
										article={article}
										key={article.id}
										refetch={refetch}
									/>
								))
							) : (
								<PlaceholderContent data={teamName} />
							)}
						</InfiniteScroll>
					</section>
				) : (
					<div
						style={{ flexGrow: 1, display: 'flex', marginTop: 110 }}
					>
						<Loading size={58} />
					</div>
				)}
			</Grid>
		</Grid>
	)
}

export default memo(Stories)
